class SideWishlist extends HTMLElement {
  static selectors = {
    item: '#wishlist-item',
    compare: '#wishlist-compare',
    selector: '#wishlist-selector',
    variant: '#wishlist-variant',
    hidden: '#wishlist-hidden',
    add: '#wishlist-add',
    show: '#wishlist-show',
    empty: '#wishlist-empty',
    items: '[data-wishlist-items]',
    loader: '[data-ripple]',
    more: '[data-more]',
  }
  wishlist; templates; page = 5; offset=0; num; shown = false; loader; more; offcanvas;
    
  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.wishlist = Utils.getWishlist();
    this.num = this.page > this.wishlist.length ? this.wishlist.length : this.page;
    this.items = this.querySelector(SideWishlist.selectors.items);
    this.more = this.querySelector(SideWishlist.selectors.more);
    this.loader = this.querySelector(SideWishlist.selectors.loader);
    if(!this.offcanvas)
      this.offcanvas = new bootstrap.Offcanvas(this);

    this.templates = {
      item: this.querySelector(SideWishlist.selectors.item).innerHTML,
      compare: this.querySelector(SideWishlist.selectors.compare).innerHTML,
      selector: this.querySelector(SideWishlist.selectors.selector).innerHTML,
      variant: this.querySelector(SideWishlist.selectors.variant).innerHTML,
      hidden: this.querySelector(SideWishlist.selectors.hidden).innerHTML,
      add: this.querySelector(SideWishlist.selectors.add).innerHTML,
      show: this.querySelector(SideWishlist.selectors.show).innerHTML,
      empty: this.querySelector(SideWishlist.selectors.empty).innerHTML,
    };

    if(this.num < this.wishlist.length){
      this.more.classList.remove('d-none');
    } 
    this.more.addEventListener('click', () => {
      this.loadMore();
    });

    this.addEventListener('shown.bs.offcanvas', (e) => { 
      if(!this.shown)
        this.show(this.offset);
    });
    
    window.addEventListener(Utils.CART_ADDING, (e) => {
      this.openLoader();
    });
    window.addEventListener(Utils.CART_ADDED, (e) => {
      this.closeLoader();
      this.close();
    });
    window.addEventListener(Utils.CART_ADD_ERROR, (e) => {
      this.closeLoader();
    });

    window.addEventListener(Utils.WISHLIST_ADDED, (e) => {
      this.update();
    });
    window.addEventListener(Utils.WISHLIST_REMOVED, (e) => {
      this.update();
      this.show(this.offset);
    });
  }

  update = () => {
    this.wishlist = Utils.getWishlist();
    this.openLoader();
    this.offset = 0;
    this.num = this.page > this.wishlist.length ? this.wishlist.length : this.page;
    this.items.innerHTML = '';
    this.shown = false;
  }

  loadMore = () => {
    this.openLoader();
    this.num += this.page;
    this.num = this.num > this.wishlist.length ? this.wishlist.length : this.num;
    this.offset = this.offset + this.page;
    this.show(this.offset);

    if(this.num < this.wishlist.length){
      this.more.classList.remove('d-none');
    } else {
      this.more.classList.add('d-none');
    }
  }

  show = (index) => {
    this.shown = true;
    if(this.num > 0){
      if(this.num > index){
        Utils.getProductByHandle(this.wishlist[index], (product) => {
          this.showProduct(product);
          this.show(index+1);
        });
      } else {
        this.closeLoader();
      }
    } else {
      var template = this.templates.empty;
      this.items.innerHTML = template;
      this.closeLoader();
    }
  }

  showProduct = (product) => {
    var template = this.templates.item;
    template = template.replaceAll(/{handle}/g, product.handle);
    template = template.replaceAll(/{id}/g, product.id);
    template = template.replaceAll(/{url}/g, product.url);
    template = template.replaceAll(/{image}/g, product.featured_image);
    template = template.replaceAll(/{title}/g, product.title);
    template = template.replaceAll(/{vendor}/g, product.vendor);
    template = template.replaceAll(/{price}/g, Utils.money(product.price));

    var compare = '';
    if(product.compare_at_price > product.price){
      compare = this.templates.compare;
      compare = compare.replaceAll(/{compare}/g, Utils.money(product.compare_at_price));
    }
    template = template.replaceAll(/{compare}/g, compare);

    var selector = '';
    if(product.available){
      if(product.variants.length > 1){
        selector = this.templates.selector;
        var options = '';
        product.variants.forEach((variant) => {
          var option = this.templates.variant;
          option = option.replaceAll(/{variant}/g, variant.id);
          option = option.replaceAll(/{title}/g, variant.title);
          options += option;
        });
        selector = selector.replaceAll(/{variants}/g, options);
      } else {
        selector = this.templates.hidden;
        selector = selector.replaceAll(/{variant}/g, product.variants[0].id);
      }
    } 
    template = template.replaceAll(/{selector}/g, selector);

    var button = '';
    if(product.available){
      button = this.templates.add;
    } else {
      button = this.templates.show;
      button = button.replaceAll(/{url}/g, product.url);
    }
    template = template.replaceAll(/{button}/g, button);

    this.items.innerHTML += template;
  }

  openLoader = () => {
    this.loader.classList.remove('d-none');
  }

  closeLoader = () => {
    this.loader.classList.add('d-none');
  }

  open = () => {
    this.offcanvas.show();
  }

  close = () => {
    this.offcanvas.hide();
  }

}
if (!window.customElements.get("side-wishlist")) {
  window.customElements.define("side-wishlist", SideWishlist);
}